import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { City } from 'src/app/_models/city.model';
import { Doctor } from 'src/app/_models/doctor.model';
import { MobileRoutes } from 'src/app/_models/routes.model';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';
import { CityService } from 'src/app/_services/city.service';
import { DoctorsService } from 'src/app/_services/doctors.service';
import { RoutesService } from 'src/app/_services/routes.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-doctor',
  templateUrl: './add-doctor.component.html',
  styleUrls: ['./add-doctor.component.scss'],
})
export class AddDoctorComponent implements OnInit {
  pageTitle: string = 'Doctors';
  routes: MobileRoutes[];
  ranks = Array(15);
  imageFile;
  medicalId;
  bsValue = new Date();
  cities: City[];

  doctorTypes = [];
  doctorTitles = [];
  specialtiesArray = [];

  languages = [];
  editMode = false;
  genderList = [{ gen: 'male' }, { gen: 'female' }];

  doctor: Doctor = { birthDate: new Date() , spokenLanguageIdsList:[]};

  constructor(
    private _DoctorsService: DoctorsService,
    private routesService: RoutesService,
    private activatedRoute: ActivatedRoute,
    private cityService: CityService,
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private specialityService: AllSpecialitiesApi
  ) {}

  ngOnInit(): void {
    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    this.specialityService.getAllSpecialties().subscribe((res) => {
      //

      this.specialtiesArray = res?.data?.doctorSpecilaities;
      //
    });
    this.cityService.getAllCities().subscribe((res) => {
      this.cities = res;
    });
    this._DoctorsService.getAllDoctorTitles().subscribe((res) => {


      this.doctorTitles = res.data;
    });
    this._DoctorsService.getAllDoctorTypes().subscribe((res) => {


      this.doctorTypes = res.data;
    });
    this._DoctorsService.getAllLanguage().subscribe((res)=>{
      this.languages = res.data;

    })

    if (this.editMode) {
      this.spinner.show();

      const id = this.activatedRoute.snapshot.params.doctorId;
      this._DoctorsService.getDoctorById(id).subscribe((res) => {
        this.doctor = res.data;
        this.doctor.doctorId = id;
        this.doctor.acceptPromoCodes =  this.doctor.acceptPromoCodes ? true : false;
        this.doctor.birthDate = new Date(res.data.birthdate);
        this.spinner.hide();
      });
    }

    this.routesService.getAllRoutes().subscribe((res) => {
      this.routes = res.data?.routes;
    });
  }

  // routeChanged(value): void {
  //   // tslint:disable-next-line: no-unused-expression
  //   !environment.production &&
  //   // tslint:disable-next-line: no-unused-expression
  //   !environment.production &&

  //   const route = this.routes.find((r) => r.id === +value);
  //   if (route) {
  //     this.doctor.id = route.id;
  //     this.doctor.name = route.routeName;
  //   }
  // }

  onImageUpload(imageFile): void {
    this.imageFile = imageFile.target.files[0];
  }
  onMedicalIdUpload(imageFile){
    this.medicalId = imageFile.target.files[0];

  }

  onAddNewDoctor(): void {
    this.spinner.show();

    if (this.editMode) {
      this._DoctorsService
        .updateDoctor(this.imageFile,this.medicalId, this.doctor)
        .subscribe((res) => {
          showNotification(
            'success',
            `${res.data.fullName} has been updated`,
            this.toastr
          );
          this.router.navigateByUrl('doctors');

          this.spinner.hide();
        });
    } else {
      this._DoctorsService
        .addNewDoctor(this.imageFile,this.medicalId, this.doctor)
        .subscribe((res) => {
          showNotification(
            'success',
            `${res.data.fullName} has been added`,
            this.toastr
          );
          this.router.navigateByUrl('doctors');

          this.spinner.hide();
        });
    }
  }
}
